export const host = "https://art-map.co.kr";
export const baseUri = "https://art-map.co.kr/api/nows";
